import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {format as stringFormat} from 'react-string-format';
import { format } from 'date-fns'; 

import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {getSortClass,converDateToLocal,convertDecimalToHHMM } from '../../utils/commonUtilities';

import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE,PAGING_END_INDEX,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,LOGIN_SUPER_ADMIN_GROUP,RANDOM_COLORS,CREW_MAX_RATING, FEEDBACK_ACTION_DEFAULT, FEEDBACK_ACTION_REQUIRED, FEEDBACK_ACTION_TAKEN} from '../../configs/staticConfigs';
import{ MSG_NOT_FOUND, MSG_FEEDBACK_UPDATED, MSG_RATING, MSG_SERVER_DATA_FETCH_ERROR, MSG_DATA_SAVE_ERROR,MSG_ACTION_TAKEN_UPDATE_SUCCESS,MSG_ACTION_TAKEN_UPDATE_ERROR} from '../../configs/msgConfigs';
import { LBL_CLIENT_FEEDBACK,LBL_CHIEF_FEEDBACK,LBL_APP_NAME, LBL_FEEDBACK, LBL_HOURS_SHORT, LBL_CLEAR_FILTERS, LBL_SLNUM, LBL_SHIFT_DATE, LBL_COMPLETED_SHIFT_CREWS, LBL_CLIENT, LBL_REVIEWED_BY, LBL_RATING, LBL_REVIEW_COMMENTS, LBL_REVIEW, LBL_SEARCH, LBL_FILTER, LBL_SHIFT, LBL_CHIEF_S, LBL_REVIEWEE, LBL_CHIEF_NOT_AVAIL, LBL_RATING_REVIEW, LBL_FEEDBACK_SEARCH, LBL_CREW_CHIEF, LBL_ACTION_TAKEN, LBL_COMPLETED, LBL_CREW, LBL_ACTION } from '../../configs/labelConfigs';

import {feedbackListAction,feedbackDetailsAction,feedbackUpdateAction,feedbackStarRatingAction, actionTakenShiftUpdateAction,actionTakenCrewUpdateAction} from '../../actions/feedbackActions'; // actionTakenShiftGetAction actionTakenCrewGetAction
import * as types from '../../actions';
import { feedbackTitle,serverTimeAction } from '../../actions/commonActions'; 

import ModalWindow from '../commons/helpers/modalWindow';
import Paginator from '../commons/helpers/paginator';
import Toast from '../commons/helpers/toast';
import Filter from '../commons/helpers/filterBy';
import FilterFeedback from './filterFeedback';

class Feedback extends Component {

   constructor(props){
      super(props)

      let userGroupData = userGroupUrlCheck(this.props.location);
      this.state = {
         userGroupData: userGroupData,
         reviewerId: userGroupData.associate_id,
         reviewerName: userGroupData.profilename,
         activePage:1,
         startIndex : 0, 
         endIndex : PAGING_END_INDEX,
         perPageCount:PAGENUMROWS_AFFILIATE,
         sortField:'-created_on',
         sortOrder:'',  
         toastMessage:'',
         toastFlag:false,
         toastSuccess:true, 
         searchString:'',    
         formErrors:{           
            rating:''
         },          
         feedbackData:{
            shift:'',
            chief:'',
            crew:'',
            starRating:0,
            reviewComments:'',   
            ratingType:0 // shift review         
         },   
         feedbackShiftList:[],
         selectedFeedbackId:0,
         rand :Math.floor(Math.random()*RANDOM_COLORS.length),
         isClientPage:false,
         isSuperAdmin:false,
         isCrewRated:false,
         selectedShiftId:'',
         searchString:'', 
         filterClicked: 0,
         resetFilterClicked: 0,
         applyFilterClicked: 0,
         applyFilter: 0,
         filtersData: {},
         clientId: 0, 
         isFilterOn: false,
         noRowsFoundMsg: '',
         expandedShiftId: 0,  
         reviewingFeedbackId: 0,
         reviewingCrewId: 0,
         starRateUpdRowShiftId: 0,
         starRateUpdRowShiftStarId:0,
         activeRowId: 0,
         actionFeedbackId: 0, 
         actionTakenType:'',
         actionTakenData: {},
         chkActionCompleted: false,
         txtActionTaken: '',
         actionTakenShiftEventTitle: '',
         actionTakenCrewName: '', 
         defaultStartDate:'',
         defaultEndDate:''
      } 
      this.onStarRatingChange    = this.onStarRatingChange.bind(this);
      this.actionTakenModal      = React.createRef(); 
      this.modal = React.createRef(); 
   }  
   
   openActionTakenModal = (actionType,actionObj,feedbackId,shiftEventTitle,crewName='') => { 
      // if(actionType=='shift') {}
      // else if(actionType=='crew') {}
      // else if(actionType=='crewChief') {}
      let chkActionCompleted = actionObj.feedback_action==FEEDBACK_ACTION_TAKEN ? true : false; 
      let txtActionTaken = actionObj.action_comment && actionObj.action_comment.length ? actionObj.action_comment :'';

      this.setState({actionTakenType:actionType,chkActionCompleted:chkActionCompleted,txtActionTaken:txtActionTaken,actionFeedbackId:feedbackId,actionTakenShiftEventTitle:shiftEventTitle, actionTakenCrewName:crewName}) 
      this.actionTakenModal.current.handleOpenModal(); 
   }

   onHandleAction = (e) => {  
      if(e.target.name=='chkActionCompleted') {
         this.setState({chkActionCompleted:e.target.checked}) 
      }
      else if(e.target.name=='txtActionTaken') {
         this.setState({txtActionTaken:e.target.value}); 
      }
   }

   onHandleChange = (e) =>{
      const {name,value}  = e.target;   
      let {feedbackData} = this.state;  
      feedbackData[name]   = value;    
      this.setState({feedbackData});
   }  

   onResetFiltersButton = () => {   
      this.props.feedbackTitle(LBL_FEEDBACK);
      let resetFilterClicked = this.state.resetFilterClicked+1; 
      let defaultStartDate = format(this.state.defaultStartDate,'dd/MM/yyyy');
      this.props.feedbackTitle(LBL_FEEDBACK+ ' (from '+defaultStartDate+')');
      this.setState({resetFilterClicked,applyFilter:1}); 
      // if(this.state.applyFilter > 0) {
      //     this.setState({resetFilterClicked,applyFilter:0,activePage:1, sortOrder:'', sortField:'-created_on', searchQuote:''}, () => {
      //       this.props.feedbackListAction({pageSize:this.state.perPageCount,page:1,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
              
      //         if(this.state.isFilterOn) {
      //             document.getElementById("filterIcon").classList.add('active');   
      //         }
      //         else if(!this.state.isFilterOn) {
      //             document.getElementById("filterIcon").classList.remove('active');   
      //         }
      //     });
      // }
      // else {
      //     this.setState({resetFilterClicked,applyFilter:0}); 
      // }
   }

   onApplyFilterButton = () => {
      this.props.feedbackTitle(LBL_FEEDBACK);
      let applyFilterClicked = this.state.applyFilterClicked+1; 
      this.setState({applyFilterClicked}); 
   }

   applyFilters = (filtersData) => {
      // RESET ALL LISTING VALUES TO DEFAULT AND ADD FILTER FLAG AND FILTER DATA 
      let applyFilter = 0; 
      if(filtersData.filtersSelected > 0) applyFilter = 1; 
      let sortOrder = ''; 
      let sortField = '-created_on'; 
      // if(filtersData.selectedStartDate!==0) sortField = '-start_date'; 
      this.setState({activePage:1, sortOrder:sortOrder, sortField:sortField, applyFilter:applyFilter, filtersData:filtersData}, () => { 
         console.log('filtersData: ',JSON.stringify(filtersData)); 
         this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:applyFilter,filtersData:filtersData});
      }); 
  }


   onShowFilterBy = () => {
      let filterClicked = (this.state.filterClicked+1);
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
      document.getElementById("filterByMenu").classList.toggle('active');      
      document.getElementById("filterIcon").classList.toggle('active');   
      // let filterByMenu = document.getElementById('filterByMenu');    
      // let filterTab = document.getElementById('filterTab');
      // filterTab.style.display = 'block';        
      // if(this.state.isFilterOn){
      //     filterByMenu.style.width='450px';
      //     filterByMenu.style.right='-450px';
      // }else{
      //     filterByMenu.style.width='450px';
      //     filterByMenu.style.right='0';
      // }
   }

   applySearch = (e)=>{
      let strVal = e.target.value; 
      this.setState({searchString:strVal}, () => {  
         if(strVal.length >=3 || strVal.length===0) {
            this.props.feedbackListAction({pageSize:this.state.perPageCount,page:1,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
         }
      })
   }

   onHandleChange = (e) =>{
      const {name,value}  = e.target;   
      let {feedbackData} = this.state;  
      feedbackData[name]   = value;    
      this.setState({feedbackData});
   }  

   onStarRatingChange = (e) =>{
      let {feedbackData,formErrors} = this.state; 
      let starId = Number(e.target.dataset.id);     
      feedbackData['starRating'] = starId;
      formErrors['rating'] = ''; 
      this.setState({feedbackData,formErrors}); 
   }

   onStarRateUpdate = (e) =>{ // star rating from listing page
      let {feedbackShiftList} = this.state; 
      let starId = Number(e.target.dataset.id);     
      let feedbackId = Number(e.target.dataset.feedback);     
      let ratingType = Number(e.target.dataset.type);   
      let shiftId =   Number(e.target.dataset.shift); 
      let isCrewRated = false;
      let starRateUpdRowShiftId = 0; 
      let starRateUpdRowShiftStarId = 0; 
      let data= {
         star_rating:starId,
         id:feedbackId,
         ratingType:ratingType
      }

      if(ratingType===0){ // for shift rating
         starRateUpdRowShiftId = shiftId; 
         starRateUpdRowShiftStarId = starId; 
         // feedbackShiftList.find((o) => o.id === feedbackId).star_rating = starId;
      }else{
         feedbackShiftList.find((o) => o.shift.id === shiftId).crews.find((p) => p.id === feedbackId).star_rating = starId;      
         isCrewRated = true;          
         this.setState({selectedShiftId:shiftId });
      }
      this.setState({feedbackShiftList,isCrewRated:isCrewRated,reviewingFeedbackId:feedbackId,starRateUpdRowShiftId, starRateUpdRowShiftStarId});
      this.props.feedbackStarRatingAction(data); 
   }

   onSaveActionTaken = () => {
      let dataObj = {
         feedbackId: this.state.actionFeedbackId,
         feedback_action: this.state.chkActionCompleted ? FEEDBACK_ACTION_TAKEN : FEEDBACK_ACTION_REQUIRED, 
         action_comment: this.state.txtActionTaken
      }; 

      if(parseInt(this.state.actionFeedbackId,10) > 0) {
         if(this.state.actionTakenType=='shift') {
            this.props.actionTakenShiftUpdateAction(dataObj); 
         }
         else if(this.state.actionTakenType=='crew' || this.state.actionTakenType=='crewChief') { 
            this.props.actionTakenCrewUpdateAction(dataObj); 
         } 
      }
   }

   onSaveFormData = (feedbackId) =>{

      const {feedbackData,formErrors} = this.state;
      
      if(feedbackData.starRating>0){     
         let data= {
            star_rating:feedbackData.starRating,
            review_comment:feedbackData.reviewComments,
            id:feedbackId,
            ratingType:feedbackData.ratingType
         }
         this.props.feedbackUpdateAction(data);               
      }else{   
         formErrors['rating'] = MSG_RATING; 
         this.setState({formErrors});
      }
   }       
   
   editFeedBackInner = (e,shiftId,crewFeedbackId,ratingType,reviewingFeedbackId) => {
      this.setState({selectedFeedbackId:shiftId,expandedShiftId:shiftId})
      this.editFeedBack(e,shiftId,crewFeedbackId,ratingType,crewFeedbackId,reviewingFeedbackId); 
   }

   editFeedBack = (e,shiftId,feedbackId,ratingType,reviewingCrewId,reviewingFeedbackId) =>{ 
      this.modal.current.handleOpenModal(); 
      let {feedback,feedbackDetails} = this.props;
      let {feedbackData} = this.state;
      let selectedfeedback = [];
      if(ratingType===0){ // shit review
         selectedfeedback = feedback.filter(i => i.id === feedbackId);  
         feedbackData['shift'] = selectedfeedback[0].shift.title+' @ '+selectedfeedback[0].shift.event_title; 
         feedbackData['ratingType']  = 0;         
         feedbackData['starRating']  = selectedfeedback[0].star_rating; 
         feedbackData['reviewComments'] = selectedfeedback[0].review_comment===null?'':selectedfeedback[0].review_comment;
      }else{ //crew review
         if(feedbackDetails.length>0){
            // let tempObj = this.state.feedbackShiftList;
            // let newFeedObj = tempObj.filter(fsDet => {Number(i.id) === Number(feedbackId)); 
            // selectedfeedback = this.state.feedbackShiftList.filter(i => Number(i.shift.id) === Number(shiftId));
            selectedfeedback = feedbackDetails.filter(i => Number(i.id) === Number(feedbackId));
            if(selectedfeedback.length) {
               feedbackData['shift'] = selectedfeedback[0].shift_title+' @ '+selectedfeedback[0].event_title;
               feedbackData['chief'] = selectedfeedback[0].chiefs;
               feedbackData['crew'] = {
                  avatar_name:selectedfeedback[0].avatar_name,
                  profile_color:selectedfeedback[0].profile_color,
                  profileImage:selectedfeedback[0].crew_profile_image,
                  name:selectedfeedback[0].crew_name,
                  skill:selectedfeedback[0].skill_name,
                  omnuPoints:selectedfeedback[0].crew_omnu_points,
                  payLevelName:selectedfeedback[0].pay_level_name
               };   
               feedbackData['ratingType']  = 1; 
               feedbackData['starRating']  = selectedfeedback[0].star_rating; 
               feedbackData['reviewComments'] = selectedfeedback[0].review_comment===null?'':selectedfeedback[0].review_comment;
            }  
            else {
                
            } 
         }         
      } 
      let rfId = reviewingFeedbackId > 0 ? reviewingFeedbackId : feedbackId; 
      this.setState({feedbackData,selectedFeedbackId:feedbackId,reviewingFeedbackId:rfId,reviewingCrewId:reviewingCrewId});
   }   

   onLoadShift = (shiftId,isExpand)=>{
      let newFeedObj = {}
      let tempObj = this.state.feedbackShiftList;
      if(!isExpand){
         newFeedObj = tempObj.map(item => {
            if(item.shift.id===shiftId) {
               item['isExpand'] = true; 
            }
            else {
               item['isExpand'] = false; 
            }
            return item;  
         })
         this.setState({feedbackShiftList:newFeedObj,expandedShiftId:shiftId}, () => {
            this.props.feedbackDetailsAction({shiftId:shiftId});
         }); 
      }else{
         newFeedObj = tempObj.map(item => {
            if(item.shift.id===shiftId) {
               item['crews'] = [];
               item['isExpand'] = false;
            }
            return item;
         })
         this.setState({feedbackShiftList:newFeedObj,expandedShiftId:0});
      }
   }
   
   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.feedbackListAction({pageSize:this.state.perPageCount,page:previousPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {
      this.props.feedbackListAction({pageSize:this.state.perPageCount,page:e.target.id,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
 
      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.feedbackListAction({pageSize:this.state.perPageCount,page:nextPage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

   onSort = (event,sortKey) =>{        
      let sOrder = '';
      if(this.state.sortField===sortKey){         
          sOrder = (this.state.sortOrder==='-') ? '' : '-';
          this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:sOrder+sortKey,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
          this.setState({ sortOrder:sOrder });            
      }else{
          this.setState({ sortField:sortKey });
          this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:sortKey,search:encodeURIComponent(this.state.searchString),applyFilter:this.state.applyFilter,filtersData:this.state.filtersData});
      }        
   }

   onModalFormReset = () =>{       
      this.setState({
         feedbackId:'',
         formErrors:{
            rating:'',          
         },
         actionFeedbackId: 0, 
         actionTakenType:'',
         actionTakenData: {},
         chkActionCompleted: false,
         txtActionTaken: '',
         actionTakenShiftEventTitle: '',
         actionTakenCrewName: '', 
      }); 
   }

   onCloseToast = () =>{
      this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
   } 

   setToasterState(isEnabled,message,isSucces,ms=3000){
      this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
      setTimeout(()=> {
          this.onCloseToast();
      }, ms);
   }

   setStateUpdate(numRows,totalPage,activity,errorData,feedback,feedbackDetails){
      let arrResp = activity ? activity.split('~~') : []; 
      let actString = arrResp[0] ? arrResp[0] : ''; 

      if(actString===types.ACTION_TAKEN_SHIFT_UPDATE_SUCCESS || actString===types.ACTION_TAKEN_CREW_UPDATE_SUCCESS){ 
         this.actionTakenModal.current.handleModelClose(); 
         this.setToasterState(true,MSG_ACTION_TAKEN_UPDATE_SUCCESS,true);
         this.onLoadShift(this.state.expandedShiftId,true); 
         this.onApplyFilterButton();
      }
      else if(actString===types.ACTION_TAKEN_SHIFT_UPDATE_ERROR || actString===types.ACTION_TAKEN_CREW_UPDATE_ERROR){ 
         this.actionTakenModal.current.handleModelClose(); 
         this.setToasterState(true,MSG_ACTION_TAKEN_UPDATE_ERROR,false);
      } 
      else if(actString===types.FEEDBACK_LIST_SUCCESS){  
         let noRowsFoundMsg = ''; 
         feedback = feedback.map(item => {
            item['isExpand'] = false;
            return item;
         });
         if(Array.isArray(feedback) && feedback.length===0) noRowsFoundMsg = MSG_NOT_FOUND; 
         this.setState({feedbackShiftList:feedback,noRowsFoundMsg}, () => {
            // EXPAND LAST OPENED ROW 
            // if(this.state.expandedShiftId > 0) { 
            //    this.onLoadShift(this.state.expandedShiftId,false); 
            // }
         }); 
      }else if(actString===types.FEEDBACK_LIST_ERROR){
         this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false); // JSON.stringify(errorData)
      }else if(actString===types.FEEDBACK_DETAILS_SUCCESS){    
         let newFeedObj = {}
         let tempObj = this.state.feedbackShiftList;
         if(feedbackDetails.length>0){
            newFeedObj = tempObj.map(item => {
               if(item.shift.id===feedbackDetails[0].shift_id) {
                  item['crews'] = feedbackDetails;
                  item['isExpand'] = true;
               }
               return item;
            })
            this.setState({feedbackShiftList:newFeedObj});
         } 
         else {
            this.setToasterState(true,MSG_NOT_FOUND,false);
         }     
      }else if(actString===types.FEEDBACK_DETAILS_ERROR){
         this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false); // JSON.stringify(errorData)
      }else if(actString===types.FEEDBACK_UPDATE_SUCCESS){ // FEEDBACK_STAR_RATING_SUCCESS
         this.setToasterState(true,MSG_FEEDBACK_UPDATED,true);
         this.modal.current.handleModelClose(); 
         // IF SHIFT REVIEW  
         if(this.state.reviewingFeedbackId > 0 && this.state.reviewingCrewId===0) {
            let newFeedObj = [];
            let tempObj = this.state.feedbackShiftList;
            newFeedObj = tempObj.map(item => {
               if(item.id===this.state.reviewingFeedbackId) { 
                  item['reviewer_id']     = this.state.reviewerId;
                  item['reviewer_name']   = this.state.reviewerName;
                  item['star_rating']     = this.state.feedbackData.starRating;
                  item['review_comment']  = this.state.feedbackData.reviewComments; 
               }
               return item;
            })
            this.setState({feedbackShiftList:newFeedObj}); 
         } // IF SHIFT CREW REVIEW  
         else if(this.state.reviewingFeedbackId > 0 && this.state.reviewingCrewId > 0) {
            let allCrewObj = {}
            let newCrewObj = {}
            let newFeedObj = {}
            let tempObj = this.state.feedbackShiftList;
            newFeedObj = tempObj.map(item => {
               if(item.id===this.state.reviewingFeedbackId) { 
                  allCrewObj = item.crews; 
                  newCrewObj = allCrewObj.map(crewItem => {
                     if(crewItem.id===this.state.reviewingCrewId) { 
                        crewItem['reviewer_id']     = this.state.reviewerId;
                        crewItem['reviewer_name']   = this.state.reviewerName;
                        crewItem['star_rating']     = this.state.feedbackData.starRating;
                        crewItem['review_comment']  = this.state.feedbackData.reviewComments; 
                     }
                     return crewItem;
                  })
                  item.crews = newCrewObj;  
               }
               return item;
            })
            this.setState({feedbackShiftList:newFeedObj}); 
         }
         // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:this.state.searchString});
      }else if(actString===types.FEEDBACK_UPDATE_ERROR){
         this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
      }else if(actString===types.FEEDBACK_STAR_RATING_SUCCESS){
         // IF SHIFT REVIEW  
         if(Number(this.state.starRateUpdRowShiftId) > 0 && Number(this.state.starRateUpdRowShiftId) > 0) {
            let starRateUpdRowShiftId     = this.state.starRateUpdRowShiftId;
            let starRateUpdRowShiftStarId = this.state.starRateUpdRowShiftStarId;
            let feedbackShiftList         = this.state.feedbackShiftList;
            feedbackShiftList.find((o) => o.id === starRateUpdRowShiftId).star_rating = starRateUpdRowShiftStarId;
            feedbackShiftList.find((o) => o.id === starRateUpdRowShiftId).reviewer_id = this.state.reviewerId;
            feedbackShiftList.find((o) => o.id === starRateUpdRowShiftId).reviewer_name = this.state.reviewerName;
            this.setState({feedbackShiftList,starRateUpdRowShiftId:0,starRateUpdRowShiftStarId:0}); 
         }
         if(this.state.isCrewRated){ // to get the crew's avg rating after rating
         this.onLoadShift(this.state.selectedShiftId,false)
         }
         //this.setToasterState(true,MSG_FEEDBACK_RATING_UPDATED,true);        
      }else if(actString===types.FEEDBACK_STAR_RATING_ERROR){
         this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
         this.setState({starRateUpdRowShiftId:0,starRateUpdRowShiftStarId:0}); 
      }     
   } 

   componentDidUpdate(prevProps) {
      const {isFilterOn,numRows,totalPage,activity,errorData,feedback,feedbackDetails} = this.props;   
      if (isFilterOn !== prevProps.isFilterOn) {
         this.inputFilter.click();   
      } 
      if (activity !== prevProps.activity) {
         this.setStateUpdate(numRows,totalPage,activity,errorData,feedback,feedbackDetails);
      }
      if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let defaultStartDate = new Date();
                defaultStartDate = new Date(defaultStartDate.setDate(defaultEndDate.getDate() - 30));
                this.setState({defaultStartDate:defaultStartDate,defaultEndDate:defaultEndDate},()=>{
                    defaultStartDate = format(defaultStartDate,'dd/MM/yyyy');
                    this.props.feedbackTitle(LBL_FEEDBACK+ ' (from '+defaultStartDate+')');
                    this.onApplyFilterButton();
                })
            }
      } 
   }

   componentDidMount() {
        const { location } = this.props;
      
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
            this.setState({isClientPage:false});  
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
            this.setState({isClientPage:true});  
        }
        else if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
         this.setState({isSuperAdmin:true});  
        }
        

        document.title = LBL_APP_NAME+" - "+LBL_FEEDBACK;
        // this.onApplyFilterButton();
        this.props.serverTimeAction();   
        // this.props.feedbackListAction({pageSize:this.state.perPageCount,page:this.state.activePage,sortBy:this.state.sortOrder+this.state.sortField,search:encodeURIComponent(this.state.searchString)}); 
   }   

   justClick = () => {

   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
          this.setState({activeRowId:rowId}); 
          document.getElementById("img-action-"+rowId).focus();
      }
      else if(this.state.activeRowId===rowId){ 
          this.setState({activeRowId:0}); 
      }
      else if(this.state.activeRowId!==rowId){   
          dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
          dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
          dropdown.classList.toggle('show');
          dropdownMenu.classList.toggle('show');
          this.setState({activeRowId:rowId}); 
          document.getElementById("img-action-"+rowId).focus();
      }        
   }   
  
   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   render(){

      const {
         activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,feedbackData,feedbackShiftList,formErrors,selectedFeedbackId,rand,isClientPage,isSuperAdmin,searchString,sortField,sortOrder,            
     } = this.state  

      const {totalPage,status } = this.props; 
      let is_active = true; 
      let userGroupData = userGroupUrlCheck(this.props.location);
      let userGroup = ''; 
      let lbl_chief_no_avai = '';
      let crew_chief_text = ''; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
         is_active = userGroupData.is_active; 
         lbl_chief_no_avai = stringFormat(LBL_CHIEF_NOT_AVAIL,userGroupData.supervisor_name); 
         crew_chief_text = userGroupData.supervisor_name; 
      }
      if(!lbl_chief_no_avai){
        lbl_chief_no_avai = stringFormat(LBL_CHIEF_NOT_AVAIL,'chief'); 
      }
      if(!crew_chief_text){
         crew_chief_text = LBL_CREW_CHIEF
      }

      if(status===401 || status===403){
         if(userGroup===LOGIN_AFFILIATE_GROUP){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
         }else{
            return <Redirect to={ROUTE_REFRESH} />;
         }
      }     
     
      let timeZone =  getUserTimeZone(this.props.location);

      let profileImgTag = '';

      if(feedbackData.crew){
         let imageClass = 'img-fluid img-prof-small';

         profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={feedbackData.crew.name} title={feedbackData.crew.name} />;

         if ((feedbackData.crew.profileImage) && feedbackData.crew.profileImage.trim().length > 0){
               profileImgTag = <img className={imageClass} src={feedbackData.crew.profileImage} alt={feedbackData.crew.name} title={feedbackData.crew.name} />;
         }else if(((!feedbackData.crew.profileImage) || feedbackData.crew.profileImage.trim().length===0) && feedbackData.crew.avatar_name && feedbackData.crew.avatar_name.trim().length > 0){
            
         profileImgTag = <div title={feedbackData.crew.name} className='center-align img-fluid img-prof-small img-avatar' style={{ background:feedbackData.crew.profile_color,borderColor:feedbackData.crew.profile_color}}>{feedbackData.crew.avatar_name}</div>;
         }
      }    
      let chiefs = feedbackData.chief!==''?feedbackData.chief.map(item => item.chief_name):[];

      return(
         <React.Fragment>
            <div className="col-md-12">
               <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
               <div className="box">

                  <div className="box-head">
                     <div className="dataTables_filter"><label>
                        <input type="search" className="" placeholder={LBL_FEEDBACK_SEARCH} id="my-search-input" onChange={this.applySearch} value={searchString} /></label>
                     </div>    
                     <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 450, hide: 250 }}
                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                opacity: 0.4,
                              }}>
                            {LBL_FILTER}
                          </Tooltip>}
                        > 
                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>
                        </OverlayTrigger>
                     </div>
                     {this.state.applyFilter > 0 && 
                        <div className="text-12 div150" onClick={this.onResetFiltersButton} >&nbsp; &nbsp; <Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>} 
                  </div>


                  <div className="box-content">
                     <div className="table-responsive feedback">
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th></th>
                                 <th>{LBL_SLNUM} </th>                                
                                 <th onClick={(e) => this.onSort(e,'shift__start_datetime')} className="shift-date spanPointer" >{LBL_SHIFT_DATE} <i className={sortField=='shift__start_datetime' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 <th className="padding-right-5 min-width-350 shift-crew spanPointer" onClick={(e) => this.onSort(e,'shift__title')} >{LBL_COMPLETED_SHIFT_CREWS} <i className={sortField=='shift__title' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                 {(!isClientPage || isSuperAdmin) && 
                                 <th >{LBL_CLIENT+'/'+crew_chief_text}</th>
                                 }
                                 {!isClientPage &&<th>{LBL_CLIENT_FEEDBACK+'?'}</th>}
                                 {!isClientPage &&<th>{LBL_CHIEF_FEEDBACK+'?'}</th>}
                                 <th>{LBL_REVIEWED_BY}</th>
                                 <th className="width100">{LBL_RATING}</th>
                                 <th className="width-15">{LBL_REVIEW_COMMENTS} </th>   
                                 {isClientPage && is_active===true && 
                                    <th className="text-center">{LBL_REVIEW}</th>                        
                                 }
                                 {!isClientPage && <th className="width100">{LBL_ACTION_TAKEN}</th>}
                                 {!isClientPage && !isSuperAdmin && <th className="width100">{' '}</th>}
                              </tr>
                           </thead>
                           <tbody>
                           {(this.state.noRowsFoundMsg && this.state.noRowsFoundMsg.length > 1)  && 
                              <tr>
                                 <td colSpan="12" className="text-center">{MSG_NOT_FOUND}</td>
                              </tr>
                           }
                           { feedbackShiftList.map((item, index)  => {
                              let indeNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1; 
                              let event_start_time = converDateToLocal(item.shift.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let event_end_time = converDateToLocal(item.shift.end_datetime,timeZone.utc_offset,'hhmm');  
                              let shiftLength = convertDecimalToHHMM(item.shift.shift_length);

                              let starRating = Number(item.star_rating); 
                              let feedbackActionComment = ''; 
                              let feedbackActionRequired = 0; 

                              let shiftEventTitle = item.shift.title+' @ '+item.shift.event_title

                              if(starRating > 0 && starRating < 3) {
                                 if(Number(item.feedback_action) > 0 && item.action_comment && item.action_comment.length) {
                                    feedbackActionComment = item.action_comment;
                                 }
                                 if(Number(item.feedback_action)==Number(FEEDBACK_ACTION_REQUIRED) || Number(item.feedback_action)==Number(FEEDBACK_ACTION_TAKEN)) {
                                    feedbackActionRequired = 1; 
                                 }
                              }  

                                 return (
                                    <React.Fragment key={index}>
                                       {/* <tr className={item.isExpand?'shown':''}> */}
                                       <tr className={item.shift.id===this.state.expandedShiftId?'shown':''}> 
                                          <td className="details-control sorting_1" onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}></td>
                                          <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{indeNum}</td>
                                          <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{event_start_time} - {event_end_time} ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})</td>
                                          <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{shiftEventTitle}</td>
                                          {(!isClientPage || isSuperAdmin) && 
                                             <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{item.client_name}</td>
                                          }
                                          {!isClientPage &&<td className="text-center" onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{item.client_crew_reviewed?'Y':'N'}</td>}
                                          {!isClientPage &&<td  className="text-center" onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{item.chief_crew_reviewed?'Y':'N'}</td>}
                                          <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>{item.reviewer_name}</td>
                                          <td onClick={!isClientPage?(e) => this.onLoadShift(item.shift.id,item.isExpand):this.justClick()}>
                                             <div className="crew">
                                                <div className={isClientPage?'crew__rating':'crew__rating rating-display-only'}>
                                                {CREW_MAX_RATING.map(ratingNum => {
                                                   if(Number(ratingNum) <= starRating) {
                                                      return(
                                                         <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingshift"+item.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e) : this.justClick()} data-id={ratingNum} data-feedback={item.id} data-type="0" data-shift={item.id} disabled={!isClientPage} /><label htmlFor={"ratingshift"+item.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate checked-rate'}><i className="fas fa-star"></i></label></React.Fragment>
                                                      )
                                                   }else {                                                 
                                                      return(
                                                         <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingshift"+item.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e) : this.justClick()} data-id={ratingNum} data-feedback={item.id} data-type="0" data-shift={item.id} disabled={!isClientPage} /><label htmlFor={"ratingshift"+item.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate'}><i className="far fa-star"></i></label></React.Fragment>
                                                      )                                                     
                                                   }     
                                                })
                                                }                                                
                                                </div>
                                             </div> 
                                          </td> 
                                          <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}>
                                             {item.review_comment===null?'':item.review_comment}
                                          </td>    
                                          {isClientPage && is_active===true && 
                                             <td className="text-center"> 
                                             <Link to="#" onClick={(e) => this.editFeedBack(e,item.shift.id, item.id,0,0,0)}>{LBL_REVIEW}</Link>
                                             </td>
                                          }  
                                          
                                          {!isClientPage && <td onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}> {Number(item.feedback_action)==Number(FEEDBACK_ACTION_TAKEN) && <i class="las la-check" title={LBL_COMPLETED}> </i> }  {feedbackActionComment}</td> }

                                          {!isClientPage && !isSuperAdmin && <td onClick="event.cancelBubble=true;" >
                                             <div className={feedbackActionRequired > 0 ? "dropdown" : "hide"} id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+item.id}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" 
                                                onMouseUp={(e) => this.onShowActionButtons(e, item.id)}
                                                >
                                                <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+item.id} id={'dropdown-menu-'+item.id}>
                                                <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.openActionTakenModal('shift',item,item.id,shiftEventTitle)}>{LBL_ACTION}</Link>
                                                </div>
                                             </div>
                                          </td>}                                         
                                       </tr> 


                                    {  
                                    item.shift.id===this.state.expandedShiftId && item.hasOwnProperty('crews') && item.crews.length>0?
                                       item.crews.map((crew, index2)  => {  
                                          let imageClass = crew.is_crew_chief?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                          let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew.crew_name} title={crew.crew_name} />;
   
                                          if ((crew.crew_profile_image) && crew.crew_profile_image.trim().length > 0){
                                                profileImgTag = <img className={imageClass} src={crew.crew_profile_image} alt={crew.crew_name} title={crew.crew_name} />;
                                          }else if(((!crew.crew_profile_image) || crew.crew_profile_image.trim().length===0) && crew.avatar_name && crew.avatar_name.trim().length > 0){
                                             
                                          profileImgTag = <div title={crew.crew_name} className={crew.is_crew_chief?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crew.profile_color,borderColor:crew.profile_color}}>{crew.avatar_name}</div>; 
                                          }
                                          const chiefIcon = crew.is_crew_chief? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                                       
                                          let chief_reviews = crew.chief_reviews ? crew.chief_reviews : []; 
                                       
                                          // FOR TESTING 
                                          // let chief_reviews = [
                                          //    {
                                          //        "id": 60,
                                          //        "star_rating": 3,
                                          //        "review_comment": "Checking##",
                                          //        "reviewer_id": 31,
                                          //        "reviewer_name": "abdul nasar"
                                          //    }
                                          // ]; 

                                          let crewId = 'crew'+crew.id; 
                                          let crewStarRating = Number(crew.star_rating); 
                                          let crewFeedbackActionComment = ''; 
                                          let crewFeedbackActionRequired = 0; 

                                          if(crewStarRating > 0 && crewStarRating < 3) {
                                             if(Number(crew.feedback_action) > 0 && crew.action_comment && crew.action_comment.length) {
                                                crewFeedbackActionComment = crew.action_comment;
                                             }
                                             if(Number(crew.feedback_action)==Number(FEEDBACK_ACTION_REQUIRED) || Number(crew.feedback_action)==Number(FEEDBACK_ACTION_TAKEN)) {
                                                crewFeedbackActionRequired = 1;
                                             }
                                          }  

                                       return(
                                          <>
                                          <tr key={index+index2}>
                                          <td></td>
                                          <td></td>
                                          <td></td>                                             
                                          <td>  
                                             <div className="crew">
                                                <div className="crew__aside">
                                                   <div className="crew__thumb">
                                                      {profileImgTag}
                                                   </div>
                                                   <span className="crew__badge">{crew.crew_omnu_points}</span>
                                                </div> 
                                                <div className="crew__content content-feedback">
                                                <span>{chiefIcon}</span><b>{crew.crew_name}</b> <span className="ml-1">({crew.skill_name})</span>
                                                   <p className="mb-0"><small>{crew.pay_level_name}</small></p>
                                                   <div className="crew">
                                                      <div className="crew__rating rating-display-only">
                                                      {CREW_MAX_RATING.map(ratingNum => {
                                                         if(Number(ratingNum) <= Number(crew.crew_total_rating)) {
                                                            return(
                                                               <React.Fragment key={'ratingcrew'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingcrew"+crew.id+ratingNum} disabled={true} /><label htmlFor={"ratingcrew"+crew.id+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                         )
                                                         }else {
                                                            if(parseFloat(ratingNum)-0.5===parseFloat(crew.crew_total_rating)){
                                                               return(
                                                                  <React.Fragment key={'ratingcrew'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingcrew"+crew.id+ratingNum} disabled={true} /><label htmlFor={"ratingcrew"+crew.id+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                               )
                                                            }else{
                                                               return(
                                                                  <React.Fragment key={'ratingcrew'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingcrew"+crew.id+ratingNum} disabled={true} /><label htmlFor={"ratingcrew"+crew.id+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                               )
                                                            }
                                                         }
                                                         
                                                      })
                                                      }
                                                      </div>
                                                   </div> 
                                                </div>
                                             </div>                                             
                                          </td>
                                          {!isClientPage &&
                                             <td>{crew.client_name}</td>
                                          }
                                          <td>{crew.reviewer_name}</td>
                                          <td>  
                                             <div className="crew">
                                                <div className={isClientPage?'crew__rating':'crew__rating rating-display-only'}>
                                                
                                                {CREW_MAX_RATING.map(ratingNum => {
                                                   if(Number(ratingNum) <= Number(crew.star_rating) ) {
                                                      return(
                                                         <React.Fragment key={'ratingcrewshift'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingcrewshift"+crew.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e):this.justClick()} data-id={ratingNum} data-feedback={crew.id} data-type="1" data-shift={crew.shift_id} disabled={!isClientPage} /><label htmlFor={"ratingcrewshift"+crew.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate checked-rate'}><i className="fas fa-star"></i></label></React.Fragment>
                                                      )
                                                   }else {
                                                
                                                      return(
                                                         <React.Fragment key={'ratingcrewshift'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingcrewshift"+crew.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e) : this.justClick()} data-id={ratingNum} data-feedback={crew.id} data-type="1" data-shift={crew.shift_id} disabled={!isClientPage} /><label htmlFor={"ratingcrewshift"+crew.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate'}><i className="far fa-star"></i></label></React.Fragment>
                                                      )
                                                      
                                                   }
                                                   
                                                })
                                                }                                                
                                                </div>
                                             </div>                                      
                                          </td> 
                                          <td> 
                                                 
                                             {crew.review_comment===null?'':crew.review_comment}                                     
                                          </td>    
                                          {isClientPage && is_active===true && 
                                             <td className="text-center">
                                             <Link to="#" onClick={(e) => this.editFeedBackInner(e, item.shift.id,crew.id,1,item.id)}>{LBL_REVIEW}</Link>                                            
                                          </td>
                                          }  

                                          {!isClientPage && <td>
                                             {Number(crew.feedback_action)==Number(FEEDBACK_ACTION_TAKEN) && <i class="las la-check" title={LBL_COMPLETED}> </i>  }  
                                             {crewFeedbackActionComment}</td>}

                                          {!isClientPage && !isSuperAdmin && <td onClick="event.cancelBubble=true;" >
                                             <div  className={crewFeedbackActionRequired > 0 ? "dropdown" : "hide"} id={'dropdown-'+crewId}>
                                                <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+crewId}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  onMouseUp={(e) => this.onShowActionButtons(e, crewId)}
                                                >
                                                <input type="image" id={"img-action-"+crewId} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, crewId)} ></input>
                                                </button>
                                                <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+crewId} id={'dropdown-menu-'+crewId}>
                                                <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.openActionTakenModal('crew',crew,crew.id,shiftEventTitle,crew.crew_name)}>{LBL_ACTION}</Link>
                                                </div>
                                             </div> 
                                          </td>}                             
                                       </tr>  


                                       {chief_reviews && Array.isArray(chief_reviews) && chief_reviews.length > 0 && chief_reviews.map(crItem => {
                                             let crewChiefId = 'crewChief'+crItem.id; 
                                             let crewChiefStarRating = Number(crItem.star_rating); 
                                             let crewChiefFeedbackActionComment = ''; 
                                             let crewChiefFeedbackActionRequired = 0; 

                                             if(crewChiefStarRating > 0 && crewChiefStarRating < 3) {
                                                if(Number(crItem.feedback_action) > 0 && crItem.action_comment && crItem.action_comment.length) {
                                                   crewChiefFeedbackActionComment = crItem.action_comment;
                                                }
                                                if(Number(crItem.feedback_action)==Number(FEEDBACK_ACTION_REQUIRED) || Number(crItem.feedback_action)==Number(FEEDBACK_ACTION_TAKEN)) {
                                                   crewChiefFeedbackActionRequired = 1;
                                                }
                                             }  
                                             return(
                                                <tr>
                                                   <td></td>
                                                   <td></td>
                                                   <td></td>
                                                   <td></td>
                                                   <td>{crew_chief_text}</td>
                                                   <td>{crItem.reviewer_name}</td>
                                                   <td>
                                                      <div className="crew">
                                                         <div className={'crew__rating rating-display-only'}>
                                                
                                                            {CREW_MAX_RATING.map(ratingNum => {
                                                               if(Number(ratingNum) <= Number(crItem.star_rating) ) {
                                                                  return(
                                                                     <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingshift"+crItem.id+ratingNum}  data-id={ratingNum} data-feedback={crItem.id} data-type="1" data-shift={crItem.shift_id} disabled={true} /><label htmlFor={"ratingshift"+crItem.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate checked-rate'}><i className="fas fa-star"></i></label></React.Fragment>
                                                                  )
                                                               }else {
                                                            
                                                                  return(
                                                                     <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingshift"+crItem.id+ratingNum}  data-id={ratingNum} data-feedback={crItem.id} data-type="1" data-shift={crItem.shift_id} disabled={true} /><label htmlFor={"ratingshift"+crItem.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate'}><i className="far fa-star"></i></label></React.Fragment>
                                                                  )
                                                                  
                                                               }
                                                               
                                                            })
                                                            }                                                
                                                         </div>
                                                      </div>
                                                   </td>
                                                   <td>{crItem.review_comment}</td>

                                                   {!isClientPage && <td>
                                                      {Number(crItem.feedback_action)==Number(FEEDBACK_ACTION_TAKEN) && <i class="las la-check" title={LBL_COMPLETED}> </i> }  
                                                      {crewChiefFeedbackActionComment}
                                                   </td>}

                                                   {!isClientPage && !isSuperAdmin && <td onClick="event.cancelBubble=true;" >
                                                      <div className={crewChiefFeedbackActionRequired > 0 ? "dropdown" : "hide"} id={'dropdown-'+crewChiefId}>
                                                         <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-'+crewChiefId}  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onMouseUp={(e) => this.onShowActionButtons(e, crewChiefId)} >
                                                            <input type="image" id={"img-action-"+crewChiefId} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, crewChiefId)} ></input>
                                                         </button>
                                                         <div className="dropdown-menu" aria-labelledby={'dropdownMenuButton-'+crewChiefId} id={'dropdown-menu-'+crewChiefId}>
                                                         <Link className="dropdown-item edit" to="#"  onMouseDown={(e) => this.openActionTakenModal('crewChief',crItem,crItem.id,shiftEventTitle,crew.crew_name)}>{LBL_ACTION}</Link>  
                                                         </div>
                                                      </div> 
                                                   </td>}  
                                                </tr>   
                                             )
                                          })
                                       }
                                       </>
                                          )

                                       }):<tr className="hide"></tr>
                                    }
                                    </React.Fragment>                                        
                                    )
                                 })      
                              }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>                    
               </div>              
               
               <ModalWindow ref={this.modal} header={LBL_RATING_REVIEW} saveFormData={ (e)=>this.onSaveFormData(selectedFeedbackId)} resetModalForm={this.onModalFormReset} type="save">                  
                  <div className="row mb-3">
                     <div className="col-md-12">
                           <div className="row">
                              <div className="col-md-2"><label>{LBL_SHIFT}</label></div>
                              <div className="col-md-10">
                                 <span className="review-text">{feedbackData.shift}</span>                              
                              </div>
                           </div>
                     </div>                     
                  </div>    
                  <div className={feedbackData.ratingType===0?'hide':'row mb-3'}>
                     <div className="col-md-12">
                           <div className="row">
                              <div className="col-md-2"><label>{crew_chief_text+'(s)'}</label></div>
                              <div className="col-md-10">
                                 <span className="review-text">{feedbackData.chief.length===0 ? lbl_chief_no_avai : chiefs.join(', ')}</span> 
                              </div>                             
                           </div>
                     </div>
                  </div>        
                  <div className={feedbackData.ratingType===0?'hide':'row mb-3 feedback-crew'}>
                     <div className="col-md-12">
                           <div className="row">
                              <div className="col-md-2"><label>{LBL_REVIEWEE}</label></div>
                              <div className="col-md-10">
                                 <div className="crew">
                                    <div className="crew__aside">
                                       <div className="crew__thumb">
                                          {profileImgTag}
                                       </div>
                                       <span className="crew__badge">{feedbackData.crew.omnuPoints}</span>
                                    </div> 
                                    <div className="crew__content">
                                       <b>{feedbackData.crew.name}</b> <span>({feedbackData.crew.skill})</span>
                                       <p className="mb-0"><small>{feedbackData.crew.payLevelName}</small></p>
                                    </div>
                                 </div>
                              </div>  
                           </div>
                     </div>
                    
                  </div>   
                  <div className="row mb-3">
                     <div className="col-md-12">
                           <div className="row">
                              <div className="col-md-2"><label>{LBL_RATING}</label></div>
                              <div className="col-md-10 feedback-rate feedback">
                                 <div className="crew">
                                    <div className="crew__rating">                       
                                                           
                                       {CREW_MAX_RATING.map(ratingNum => {
                                          let filledStar = Number(ratingNum) <= Number(feedbackData.starRating) ? 1 : 0; 
                                             return(
                                                <React.Fragment key={'modalRating'+ratingNum}><input type="checkbox" checked={filledStar?true:false} name='modalRating' id={"modalRating"+ratingNum} onChange={(e) => this.onStarRatingChange(e)} data-id={ratingNum} /><label htmlFor={"modalRating"+ratingNum}><i className={filledStar?"fas fa-star":"far fa-star"}></i></label></React.Fragment>
                                            ) 
                                       })
                                       }
                                    </div>                                    
                                 </div>
                              </div>
                           </div>
                     </div>
                  </div>   
                  <div className="row">
                     <div className="col-md-12">
                           <div className="form-group">
                                    <label>{LBL_REVIEW_COMMENTS}</label>
                              <textarea className="form-control" name="reviewComments" onChange={this.onHandleChange} value={feedbackData.reviewComments|| ''}></textarea>
                           </div>
                           {formErrors.rating.length>0 && 
                              <p className="text-red left-align text-12">{MSG_RATING}</p>
                           }
                     </div>
                  </div>     
               </ModalWindow>


               <ModalWindow ref={this.actionTakenModal} header={LBL_ACTION_TAKEN} type="save" resetModalForm={this.onModalFormReset} saveFormData={ (e)=>this.onSaveActionTaken(e)} >
                  <div className="row"> 
                        <div className="col-md-12">
                        
                           <div className="form-group">
                                <label>{LBL_SHIFT+': '} </label>
                                <label className="text-bold padding-left-10">{this.state.actionTakenShiftEventTitle} </label>
                           </div> 

                           {this.state.actionTakenCrewName.length > 0 && <div className="form-group">
                                <label>{LBL_CREW+': '} </label>
                                <label className="text-bold padding-left-10">{this.state.actionTakenCrewName} </label>
                           </div>} 
                           
                           <div className="form-group">
                                <label>{LBL_ACTION_TAKEN} </label>
                                <textarea className="form-control" name="txtActionTaken" onChange={this.onHandleAction} value={this.state.txtActionTaken}></textarea>
                           </div>
                           <div className="form-group right-align">                                
                                 <div className="custom-checkbox">
                                    <input type="checkbox" id="chkActionCompleted" name="chkActionCompleted" onChange={this.onHandleAction} checked={this.state.chkActionCompleted}  />
                                    <label className="checkbox" htmlFor="chkActionCompleted"></label>
                                    <label className="labeltext" htmlFor="chkActionCompleted">{LBL_COMPLETED}</label>
                                 </div>
                           </div> 
                           
                        </div>
                  </div>       
               </ModalWindow>

            </div>

            <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}>
               <FilterFeedback defaultStartDate={this.state.defaultStartDate} defaultEndDate={this.state.defaultEndDate} filterClicked={this.state.filterClicked} resetFilterClicked={this.state.resetFilterClicked} applyFilterClicked={this.state.applyFilterClicked} applyFilters={this.applyFilters} isEvent={this.state.isEvent} isClientPage={this.state.isClientPage} clientId={this.state.clientId}  onShowFilterBy={this.onShowFilterBy} crew_chief_text={crew_chief_text} />
               <div>&nbsp;</div>
            </Filter>
            
            {/* <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}> 
                <FilterFeedback  /> 
            </Filter> */}

         </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
      return {
        feedback : state.feedback.feedback,     
        feedbackDetails:state.feedback.feedbackDetails,   
        totalPage:state.feedback.feedbackTotalPage,
        status:state.feedback.status,
        activity:state.feedback.activity,
        numRows:state.feedback.feedbackNumRows,
        count:state.feedback.feedbackCount,
        errorData:state.feedback.errorData,
        isFilterOn: state.commons.isFilterOn,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity
      }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        feedbackListAction:feedbackListAction,
        feedbackDetailsAction:feedbackDetailsAction,
        feedbackUpdateAction:feedbackUpdateAction,
        feedbackStarRatingAction:feedbackStarRatingAction,
        feedbackTitle:feedbackTitle,
        actionTakenShiftUpdateAction:actionTakenShiftUpdateAction,
        actionTakenCrewUpdateAction:actionTakenCrewUpdateAction,
        serverTimeAction:serverTimeAction, 
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Feedback);